'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _ListItemText = require('@material-ui/core/ListItemText');

var _ListItemText2 = _interopRequireDefault(_ListItemText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = function styles(theme) {
    return {
        root: {
            margin: 0
        },
        // Note that these styles propagate out to components that use List, e.g. Dropdown
        primary: { // Primary typography components
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.body1.fontSize,
            fontWeight: theme.typography.fontWeightNormal,
            lineHeight: theme.typography.body2.lineHeight
        },
        secondary: { // Secondary typography components
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.caption.fontSize,
            fontWeight: theme.typography.fontWeightNormal,
            lineHeight: theme.typography.caption.lineHeight
        }
    };
};

/**
 * A component that applies correct text styling to ListItems.
 */
var ListItemText = function ListItemText(props) {
    var classes = props.classes,
        rest = _objectWithoutProperties(props, ['classes']);

    var classOverrides = {
        root: classes.root,
        primary: classes.primary,
        secondary: classes.secondary
    };

    return _react2.default.createElement(_ListItemText2.default, Object.assign({}, rest, {
        classes: classOverrides
    }));
};

ListItemText.muiName = 'ListItemText';

ListItemText.propTypes = {
    /**
     * Alias for the `primary` property.
     */
    children: _propTypes2.default.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object,
    /**
     * If `true`, the children won't be wrapped by a Typography component.
     * This can be useful to render an alternative Typography variant by wrapping
     * the `children` (or `primary`) text, and optional `secondary` text
     * with the Typography component.
     */
    disableTypography: _propTypes2.default.bool,
    /**
     * If `true`, the children will be indented.
     * This should be used if there is no left avatar or left icon.
     */
    inset: _propTypes2.default.bool,
    /**
     * The main content element.
     */
    primary: _propTypes2.default.node,
    /**
     * These props will be forwarded to the primary typography component
     * (as long as disableTypography is not `true`).
     */
    primaryTypographyProps: _propTypes2.default.object,
    /**
     * The secondary content element.
     */
    secondary: _propTypes2.default.node,
    /**
     * These props will be forwarded to the secondary typography component
     * (as long as disableTypography is not `true`).
     */
    secondaryTypographyProps: _propTypes2.default.object
};

ListItemText.defaultProps = {
    disableTypography: false,
    inset: false
};

exports.default = (0, _styles2.default)(styles)(ListItemText);